import React, { Component,useEffect } from "react";
import { useParams, } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import {ThreeDots} from 'react-loader-spinner';
import SweetAlert from "react-bootstrap-sweetalert";
import "../../App.css";
import Select from 'react-select';
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import RefreshIcon from '@mui/icons-material/Refresh';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { List } from 'react-virtualized';
import {properties} from "../../utils/properties";
import '../../assets/bootstrap-custom.css';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {updateSedute} from "./Utils";
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';


export default function Presence_CGCultura() {
  dayjs.locale('it');  
  const navigate = useNavigate();
  const [alert, setAlert] = React.useState(null)
  let {idDossier} = useParams();
  const [loading, setLoading]= React.useState(true);
  const [loading2, setLoading2]= React.useState();
  const [disabled, setDisabled]= React.useState(false);
  const [ComitatoList, setComitatoList] = React.useState([]);
  const [ConsiglioList, setConsiglioList] = React.useState([]);
  const [RevisoriList, setRevisoriList] = React.useState([]);
  const [ComitatoPresenze, setComitatoPresenze] = React.useState([]);
  const [ConsiglioPresenze, setConsiglioPresenze] = React.useState([]);
  const [orderMeeting, setOrderMeeting] = React.useState([]);    
  const [RevisoriPresenze, setRevisoriPresenze] = React.useState([]);

  //02/10/2025 START
  const [ComitatoStato, setComitatoStato] = React.useState([]);
  const [RevisoriStato, setRevisoriStato] = React.useState([]);
  const [ConsiglioStato, setConsiglioStato] = React.useState([]);
  //02/10/2025 END
  
  const [availableDates, setAvailableDates] = React.useState([]);
  const [verbaleDate, setVerbaleDate] = React.useState(null);
  
  let redirectId="current";

  const organiValues =[
    {value: "10", label:"Commissione Pianeta"},
    {value: "20", label:"Commissione Cultura"},
    {value: "30", label:"Commissione Persone"},
    {value: "40", label:"Commissione Finanza"},
    {value: "50", label:"Commissione Statuto"}
  ];

  const options = [
    { value: 0, label: "⚠️ Non ha ancora risposto" },
    { value: 1, label: "✅ Partecipa in presenza" },
    { value: 2, label: "💻 Partecipa da remoto" },
    { value: 3, label: "❌ Non partecipa" },
    { value: 4, label: "⏳ Non sa ancora" },
  ];

  const MenuList = props => {
    const rows = props.children;
    const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
      <div key={key} style={style}>{rows[index]}</div>
    );
  
    return (
      <List
        style={{ width: '100%' }}
        width={300}
        height={300}
        rowHeight={30}
        rowCount={rows.length}
        rowRenderer={rowRenderer}
      />
    )
  }

  const customStyles = {
    control: base => ({
      ...base,
      textAlign: 'left',
      height: 55,
      minHeight: 55
    })
  };

  function handleChange1(event, idDossier) {
    if (event && event.value){
        if( properties.verboseLog==1)
          console.log("P3",event, idDossier);
        if( event.value=="10"){
          if( properties.verboseLog==1)
            console.log("GO TO PIANETA");              
          navigate("/presenze_CGPianeta/");
        }
        else if( event.value=="20"){
            //CULTURA
            if( properties.verboseLog==1)
              console.log("REMAINS ON CULTURA");                                    
        }
        else if( event.value=="30"){
            //PERSONE
            if( properties.verboseLog==1)
              console.log("GO TO PERSONE");              
            navigate("/presenze_CGPersone/");
            
        }
        else if( event.value=="40"){
          //CULTURA
          if( properties.verboseLog==1)
            console.log("GO TO FINANZA");              
          navigate("/presenze_CGFinanza/");
        }
        else if( event.value=="50"){
          //STATUTO
          if( properties.verboseLog==1)
            console.log("GO TO STATUTO");              
          navigate("/presenze_CGStatuto/");
        }
        else{              
          console.log("GO TO UNKNOWN");              
          navigate("/presenze_CGPianeta/");
        }        
     }
  }

  const showAlert = () => {
    if( properties.verboseLog==1)
      console.log("showing alert");
    setAlert(
      <SweetAlert
      warning
      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
      title={"Impossibile accedere al foglio delle presenze per la seduta " + idDossier}
      text="ciao"      
      onConfirm={() => { navigate(-1) }}
      onCancel={() => { navigate(-1) }}
      confirmBtnCssClass="custom-btn custom-btn-success" 
      cancelBtnCssClass="custom-btn custom-btn-cancel"      
      confirmBtnText="Indietro"      
    >
    </SweetAlert>
    );
};

  const handleSubmit = e => {
    e.preventDefault();    
    setLoading(true);                                   
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/updatePresenzeFieldCommissioni.php";                             
    var bodyFormData=new FormData();
    bodyFormData.append('idf', idDossier);
    bodyFormData.append('role', 'submit');
    bodyFormData.append('commissione', 'cultura');
    bodyFormData.append('index', 1);
    bodyFormData.append('value', 1);

    if (!window.cordova){
        axios({
                method: 'post',
                url: endpoint,
                data: bodyFormData,
                withCredentials: true,
                headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(function (response) {
                if( properties.verboseLog==1)
                  console.log(response);
                setRevisoriList(response.data.Revisori);
                setComitatoList(response.data.Comitato);
                setConsiglioList(response.data.Consiglio);
                setComitatoPresenze(response.data.presenzeComitato);
                setConsiglioPresenze(response.data.presenzeConsiglio);
                setRevisoriPresenze(response.data.presenzeRevisori);
                 //02/10/2025                
                 setComitatoStato(response.data.statoComitato);
                 setConsiglioStato(response.data.statoConsiglio);
                 setRevisoriStato(response.data.statoRevisori);
                 //02/10/2025
                setDisabled(response.data.Submitted);
                setLoading(false);
            })
            .catch(function (response) {
                console.log("Si è verificato un errore aggiornando le presenze!");
            });

    }
    else {
      var onSuccess = function(r)
      {
        var response = JSON.parse(r);
        if( properties.verboseLog==1)
          console.log(response);
        setRevisoriList(response.Revisori);
        setComitatoList(response.Comitato);
        setConsiglioList(response.Consiglio);
        setComitatoPresenze(response.presenzeComitato);
        setConsiglioPresenze(response.presenzeConsiglio);
        setRevisoriPresenze(response.presenzeRevisori);
         //02/10/2025                
         setComitatoStato(response.statoComitato);
         setConsiglioStato(response.statoConsiglio);
         setRevisoriStato(response.statoRevisori);
         //02/10/2025
        setDisabled(response.Submitted)
        setLoading(false);
      }

      var onError = function() {}

      const bodyasString = new URLSearchParams(bodyFormData).toString();      
      window.updatePresenzeCGCultura(bodyasString,onSuccess, onError);
    }

};




  const getPresenze = (issueName) => {    
    if (!window.cordova){
      if( properties.verboseLog==1)
          console.log("GetPresenze", issueName);                
      let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/getPresenzeCommissioni.php";   
      var bodyFormData=new FormData();      
      bodyFormData.append('idf', issueName);
      bodyFormData.append('commissione', 'cultura');
      axios({
          method: 'post',
          url: endpoint,
          data: bodyFormData,
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
        .then(function (response) {
          if( properties.verboseLog==1)
            console.log("GBC", response.data);
          setRevisoriList(response.data.Revisori);
          setComitatoList(response.data.Comitato);
          setConsiglioList(response.data.Consiglio);
          setComitatoPresenze(response.data.presenzeComitato);
          setConsiglioPresenze(response.data.presenzeConsiglio);
          setRevisoriPresenze(response.data.presenzeRevisori);
          //02/10/2025
          setComitatoStato(response.data.statoComitato);
          setRevisoriStato(response.data.statoRevisori);
          setConsiglioStato(response.data.statoConsiglio);
          //02/10/2025
          setDisabled(response.data.Submitted);              
          if( properties.verboseLog==1)
            console.log("AQUI",issueName);
          if(issueName.length==8){                
              var dateTmp=issueName.substring(2,4)+"/"+issueName.substring(0,2)+"/"+issueName.substring(4,8);
              if( properties.verboseLog==1)                
                console.log("NEXT1",dateTmp);
              setVerbaleDate(dateTmp);                  
          }
          else
              setVerbaleDate(issueName);             
          setLoading(false);              
          setAlert(null);
        })
        .catch(function (error) {
          if (error.response) {
            
            if(error.response.status===404){                
              idDossier=issueName;                
              setLoading(false);
              showAlert();
            }
          }
        }
    );
    }
    else {
          var onSuccess = function(r){
            if( properties.verboseLog==1)
              console.log('notte' + r);
            var tm2=r;
            tm2.replaceAll("\n1","");
            tm2=tm2.replaceAll("\n","");
            var response = JSON.parse(tm2);
            if( properties.verboseLog==1)
              console.log("GBC", response.data);
            setRevisoriList(response.Revisori);
            setComitatoList(response.Comitato);
            setConsiglioList(response.Consiglio);
            setConsiglioPresenze(response.presenzeConsiglio);
            setComitatoPresenze(response.presenzeComitato);
            setRevisoriPresenze(response.presenzeRevisori);
            //02/10/2025
            setComitatoStato(response.statoComitato);
            setRevisoriStato(response.statoRevisori);
            setConsiglioStato(response.statoConsiglio);
            //02/10/2025
            setDisabled(response.Submitted);
            if( properties.verboseLog==1)
              console.log("AQUI",issueName);
            if(issueName.length==8){              
                var dateTmp=issueName.substring(2,4)+"/"+issueName.substring(0,2)+"/"+issueName.substring(4,8);
                if( properties.verboseLog==1)
                  console.log("NEXT2",dateTmp);
                setVerbaleDate(dateTmp);
            }
            else
                setVerbaleDate(issueName);           
            setLoading(false);            
            setAlert(null);
          }

          var onError = function() {}
          window.getPresenzeCGCultura(issueName,onSuccess, onError);
    }
}

function handleChange3(event, role, id, index) {    
    setLoading2(id);
    let val=0;
    if(event.target.checked)
        val=1
             
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/updatePresenzeFieldCommissioni.php";                                 
    var bodyFormData=new FormData();
    bodyFormData.append('idf', idDossier);
    bodyFormData.append('role', role);
    bodyFormData.append('index', index);
    bodyFormData.append('commissione', 'cultura');
    bodyFormData.append('value', val);

    if (!window.cordova){
      axios({
              method: 'post',
              url: endpoint,
              data: bodyFormData,
              withCredentials: true, 
              headers: {'Content-Type': 'multipart/form-data' }
          })
          .then(function (response) {
              if( properties.verboseLog==1)
                console.log(response);
              setRevisoriList(response.data.Revisori);
              setComitatoList(response.data.Comitato);
              setComitatoPresenze(response.data.presenzeComitato);
              setConsiglioList(response.data.Consiglio);
              setConsiglioPresenze(response.data.presenzeConsiglio);
              setRevisoriPresenze(response.data.presenzeRevisori);
              //02/10/2025
              setComitatoStato(response.data.statoComitato);
              setRevisoriStato(response.data.statoRevisori);
              setConsiglioStato(response.data.statoConsiglio);
              //02/10/2025
              setDisabled(response.data.Submitted)
              setLoading2();
          })
          .catch(function (response) {
            console.log("si èverificato un errore aggiornando il foglio presenze");
          });
      }
      else {
        var onSuccess = function(r)
        {          
          var response = JSON.parse(r);
          setRevisoriList(response.Revisori);
          setComitatoList(response.Comitato);
          setComitatoPresenze(response.presenzeComitato);         
          setConsiglioList(response.Consiglio);          
          setConsiglioPresenze(response.presenzeConsiglio);
          setRevisoriPresenze(response.presenzeRevisori);
          //02/10/2025
          setComitatoStato(response.statoComitato);
          setRevisoriStato(response.statoRevisori);
          setConsiglioStato(response.statoConsiglio);
          //02/10/2025
          setDisabled(response.Submitted)
          setLoading2();
        }

        var onError = function() {}

        const bodyasString = new URLSearchParams(bodyFormData).toString();

        window.updatePresenzeCGCultura(bodyasString,onSuccess, onError);

      }

  }
 
  function handleChange4(event, role, id, index) {
    //if( properties.verboseLog==1)  
      console.log("WERW",event.value, id);
      let val=event.value;
      setLoading2(id);    

    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/updateStatoFieldCommissioni.php";      
    var bodyFormData=new FormData();
    bodyFormData.append('idf', idDossier);
    bodyFormData.append('role', role);
    bodyFormData.append('index', index);
    bodyFormData.append('commissione', 'cultura');
    bodyFormData.append('value', val);

    if (!window.cordova){
      axios({
              method: 'post',
              url: endpoint,
              data: bodyFormData,
              withCredentials: true, 
              headers: {'Content-Type': 'multipart/form-data' }
          })
          .then(function (response) {
              if( properties.verboseLog==1)
                console.log(response);
              setRevisoriList(response.data.Revisori);
              setComitatoList(response.data.Comitato);
              setComitatoPresenze(response.data.presenzeComitato);         
              setConsiglioList(response.data.Consiglio);          
              setConsiglioPresenze(response.data.presenzeConsiglio);
              setRevisoriPresenze(response.data.presenzeRevisori);                
              setComitatoStato(response.data.statoComitato);
              setRevisoriStato(response.data.statoRevisori);
              setConsiglioStato(response.data.statoConsiglio);                
              setDisabled(response.data.Submitted)
              setLoading2();
          })
          .catch(function (response) {
            console.log("si èverificato un errore aggiornando il foglio presenze");
          });
      }
      else {
        var onSuccess = function(r){        
          var response = JSON.parse(r);
          setRevisoriList(response.Revisori);
          setComitatoList(response.Comitato);
          setComitatoPresenze(response.presenzeComitato);         
          setConsiglioList(response.Consiglio);          
          setConsiglioPresenze(response.presenzeConsiglio);
          setRevisoriPresenze(response.presenzeRevisori);                
          setComitatoStato(response.statoComitato);
          setRevisoriStato(response.statoRevisori);
          setConsiglioStato(response.statoConsiglio);                
          setDisabled(response.Submitted)
          setLoading2();
        }

        var onError = function() {}

        const bodyasString = new URLSearchParams(bodyFormData).toString();

        window.updateStatoCGCultura(bodyasString,onSuccess, onError);
      }
  }  


function formatDate(date){
    return date.substring(0,2)+"/"+date.substring(2,4)+"/"+date.substring(4,8);
}
function formatDateYMA(date){
  return date.substring(4,8)+"-"+date.substring(2,4)+"-"+date.substring(0,2);
}


const resolveCurrent2 = function(jsonList){
  if( properties.verboseLog==1)
    console.log("RC",jsonList);
  var entireMeeting = Object.entries(jsonList);
  var orderMeeting = [];
  for (var i = entireMeeting.length - 1; i >= 0; i--) {
      var eachMeeting = {
          id: entireMeeting[i][0],
          order: entireMeeting[i][1]["order"],
          date: entireMeeting[i][1]["dataSeduta"],
          };
      orderMeeting.push(eachMeeting);
      if( properties.verboseLog==1)
        console.log("11",eachMeeting);      
  }
  orderMeeting.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
  var meee=orderMeeting.shift();
  if( properties.verboseLog==1)
    console.log("SHIFT",meee);  
  idDossier=meee.id;
  redirectId=meee.id;  
  
  navigate("/presenze_CGCultura/"+redirectId,{ replace: true });
  getPresenze(idDossier);  
  if( properties.verboseLog==1)
    console.log("fine resolve current2")
}


const doPostSedute2 = function() {
  if( properties.verboseLog==1)
    console.log("doing sedute post111");
  var xhr2 = new XMLHttpRequest();  
  xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSeduteJsonCGCultura.php',true);
  xhr2.withCredentials = true;
  xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhr2.onload = function (e) {
      if (xhr2.readyState === 4) {
          if (xhr2.status === 200) {
              var responseText = xhr2.responseText;
              var obj=JSON.parse(responseText);
              var jsonListSedute;
              if(obj.status==="204" ){
                console.log("OK PRESENCE2 204",xhr2);
                jsonListSedute = JSON.parse(localStorage.getItem("listSeduteCGCultura"));
              }
              else{
                  //status 201
                  console.log("OK PRESENCE2 201",xhr2);
                  if( properties.verboseLog==1)
                    console.log("OK95",obj.date);
                  try{
                    localStorage.setItem("listSeduteCGCultura", obj.content);
                    localStorage.setItem("listSeduteVersionCGCultura", obj.date);
                  }
                  catch(error) {
                    console.log("LOCALSTORAGE ISSUE", error);
                  }
                  jsonListSedute = JSON.parse(obj.content);
              }          
          var entireMeeting = Object.entries(jsonListSedute);
          var meeting = [];
          var meetingDates=[];
          for (var i = entireMeeting.length - 1; i >= 0; i--) {
              var dateLabel=entireMeeting[i][0].substring(4, 8).concat("-").concat(entireMeeting[i][0].substring(2, 4)).concat("-").concat(entireMeeting[i][0].substring(0, 2));
              var eachMeeting = {
                  id: entireMeeting[i][0],
                  name: dateLabel.replace("/","-"),
                  location: entireMeeting[i][0],
                  startDate: dateLabel.replace("/",""),
                  color: '#30720f',
              };
              meeting.push(eachMeeting);              
              meetingDates.push(dayjs(eachMeeting.startDate));
          }
          if( properties.verboseLog==1)
              console.log("AvailableDates",meetingDates);
          setAvailableDates(meetingDates);
          if( properties.verboseLog==1){          
            console.log("2231",meeting);
            console.log("2232",meetingDates);
          }
          
          if(window.location.href.endsWith("/current")||window.location.href.endsWith("/current/")){
            resolveCurrent2(jsonListSedute);
          }
          else{
            if(idDossier!=null){
                if( properties.verboseLog==1)
                  console.log("IDS:"+idDossier,idDossier.length);
                if(idDossier.length==8)
                    getPresenze(idDossier);
                else
                    resolveCurrent2(jsonListSedute);
            }
            else{
                if( properties.verboseLog==1)
                  console.log("IDS is null");
                resolveCurrent2(jsonListSedute);
            }
          }
        }
          else {
              console.error("Error 1", xhr2.statusText);
              window.alert("Errore recuperando la lista delle sedute");
          }
          if( properties.verboseLog==1)
            console.log("fine dopostsedute2");
      }
      
  };

  xhr2.onerror = function (e) {
      console.error("Error 22", xhr2.statusText);
  };

  let urlEncodedData = null; //"idf=" + meetingId;
  if (localStorage.listSeduteCGCultura!=='' &&localStorage.listSeduteCGCultura!==undefined){
      const currentData=localStorage.getItem("listSeduteVersionCGCultura");
      urlEncodedData = "date=" + currentData;
  }
  xhr2.send(urlEncodedData);
}

const handleDateChange = (date) => {
    if( properties.verboseLog==1)
      console.log("HDC1",date);
    var rr=date.format('DDMMYYYY');
    if( properties.verboseLog==1)
      console.log("HDC2",rr);
    navigate("/presenze_CGCultura/"+rr,{ replace: true });
    setLoading(true);
    getPresenze(rr);

  };


  const updateUI = function(jsonData) {
          var entireMeeting = Object.entries(jsonData);
          var meeting = [];
          var meetingDates=[];
          for (var i = entireMeeting.length - 1; i >= 0; i--) {
              var dateLabel=entireMeeting[i][0].substring(4, 8).concat("-").concat(entireMeeting[i][0].substring(2, 4)).concat("-").concat(entireMeeting[i][0].substring(0, 2));
              var eachMeeting = {
                  id: entireMeeting[i][0],
                  name: dateLabel.replace("/","-"),
                  location: entireMeeting[i][0],
                  startDate: dateLabel.replace("/",""),
                  color: '#30720f',
              };
              meeting.push(eachMeeting);      
              meetingDates.push(dayjs(eachMeeting.startDate));
          }
          if( properties.verboseLog==1)
              console.log("AvailableDates",meetingDates);
          setAvailableDates(meetingDates);
          if( properties.verboseLog==1){          
            console.log("2231",meeting);
            console.log("2232",meetingDates);
          }
          if(window.location.href.endsWith("/current")||window.location.href.endsWith("/current/")){
            resolveCurrent2(jsonData);
          }
          else{
            if(idDossier!=null){
                if( properties.verboseLog==1)
                  console.log("IDS:"+idDossier);
                if(idDossier.length==8)
                    getPresenze(idDossier);
                else
                    resolveCurrent2(jsonData);
            }
            else{
                if( properties.verboseLog==1)
                  console.log("IDS is null");
            }
                resolveCurrent2(jsonData);
          }
  }
   
  const shouldDisableDate = (date) => {
    return !availableDates.some(eventDate => eventDate.isSame(date, 'day'));
  };

  
  

useEffect(() => {  
  if(!window.cordova){
      //CHECK AUTHENTICATION
      var xhr = new XMLHttpRequest();      
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ping.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  //doPostSedute();
                  if( properties.verboseLog==1)
                    console.log("OK",xhr);
                  doPostSedute2();
          } else {
              console.error("Error 1", xhr);
              localStorage.clear();              
              navigate("/login");
          }
      }
      };

      xhr.onerror = function (e) {
          console.error("Error 2", xhr);
          localStorage.clear();          
          navigate("/login");
      };

      let urlEncodedData = null;
      xhr.send(urlEncodedData);
      //CHECK AUTHENTICATION
    } 
    if (window.cordova){
       var onSuccess = function(data) {
          var obj = JSON.parse(data);
          var sedute = JSON.parse(obj.content);
          if( properties.verboseLog==1)
            console.log(sedute);
          updateUI(sedute);
        }

        var onError = function() {
           //alert("Impossibile scaricare l'elenco delle sedute, si prega di riprovare");
        }

        window.checkSeduteJsonCGCultura(onSuccess, onError);
    }
 
},
   []);


  return (
    <div key={uuidv4()}>
    {loading ? (
      <div key={uuidv4()} style={{ width:"25%",   display: "flex",
      marginLeft: "auto", marginRight: "auto" }}>
       <ThreeDots color="#30720f" height='350' width='150'/>
       </div>
      ):(
        <div className="content">
            <div className="presence-fab-group">
            <Tooltip title="Aggiorna" placement="left">
                      <Fab aria-label="add"                 
                          //variant="contained" 
                          onClick={(event) => {doPostSedute2() }}                
                          style={{
                              margin: 0,
                              background: "#FFC300",
                              top: 'auto',
                              right: 15,
                              bottom: 45,                    
                              left: 'auto',
                              position: 'fixed',}}>                    
                              <RefreshIcon fontSize='large'/>                 
                          </Fab>          
                    </Tooltip>

            </div>
            <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 3 } }}>
            
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it" >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={8}>
                <Box display="flex" alignItems="center" height="100%">
                  <Typography variant="body1" style={{fontWeight: "bold"}}>
                    Organo relativo alla riunione:
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>             
                <Select key={uuidv4()}     
                    isSearchable= {false}                                  
                    component={{MenuList}}  
                    fullWidth                 
                    styles={customStyles}                 
                    onChange={(event) => handleChange1(event, idDossier)}
                    defaultValue={{
                      label: "Commissione Cultura",
                      value: "20"
                    }}     
                    options={organiValues}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#a2ee7d',
                        primary: 'black',
                      },
                    })}   

                  /> 
              </Grid>

              <Grid item xs={12} sm={6} md={8}>
                    <Box display="flex" alignItems="center" height="100%">
                    <Typography variant="body1" style={{fontWeight: "bold"}}>
                    Data della riunione:
                    </Typography>
                    </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>                
                  <DatePicker
                      disableToolbar                                                                        
                      onKeyDown={(e) => {
                          e.preventDefault();
                      }}
                      value={dayjs(verbaleDate)}
                      shouldDisableDate={shouldDisableDate}
                      onChange={handleDateChange}
                      sx={{width:'100%', backgroundColor:"white", "& .MuiOutlinedInput-root": {
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "black"
                          },
                         
                      } }}
                        
                      slotProps={{                          
                          field: {
                              readOnly: true
                          },
                          day: ({ day, selectedDate, isInCurrentMonth }) => {
                            const isEventDate = availableDates.some((eventDate) => eventDate.isSame(day, 'day'));
                            const isSelected =  day.isSame(selectedDate, 'day');
                            
                            return {
                              sx: {
                                '&.Mui-selected': {
                                  backgroundColor: '#f471ae !important', 
                                  color: 'white',
                                  fontWeight: 'bold',
                                  '&:hover': {
                                    backgroundColor: '#ce0f69 !important', 
                                  },
                                },
                                ...(isEventDate && !isSelected && {
                                  backgroundColor: '#ce0f69', 
                                  color: 'white', 
                                  borderRadius: '50%',
                                  fontWeight: 'bold',
                                  '&:hover': {
                                    backgroundColor: '#77093c', 
                                  },
                                }),                          
                              },
                             
                            };
                          }                                                
                      }}                                                             
                    />
               
                 
               </Grid>
               
               <Grid item xs={12}>
                <form className="form1" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <div style={{ maxWidth: "100%",  paddingTop: "10px",width: "100%", alignItems: "left",margin: "auto"}}>
                        <Typography variant="body1" style={{textAlign: "left", fontWeight: "bold", paddingBottom:"5px",paddingTop:"15px"}}>
                        Elenco dei partecipanti alla seduta della Commissione Cultura del {formatDate(idDossier)}:                        
                        </Typography>               
                        {ConsiglioList.length>0 ?(
                             <div className="common-list" key={uuidv4()} style = {{alignItems: "center", display: "block", height: "100%", paddingTop:"20px", justifyContent: "center"}}>
                                <p className="presence-section-title" style={{ fontSize: "16px", letterSpacing: "1px", width: "100%", textAlign: "left"}}>
                                    Componenti Consiglio Generale
                                </p>
                                {ConsiglioList.map((item, index) => (                                
                                    <Grid
                                          key={uuidv4()}
                                          container
                                          alignItems="center"
                                          sx={{
                                            py: { xs: 2, sm: 1 },
                                            px: 2,
                                            mx: { xs: 1.5, sm: 0 },
                                            width: { xs: "calc(100% - 24px)", sm: "100%" },
                                            mb: { xs: 2, sm: 1 },
                                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#f0f0f0", // alternanza
                                            border: { xs: "1px solid #e0e0e0", sm: "none" },
                                            borderRadius: { xs: 2, sm: 0 },
                                            boxShadow: { xs: 1, sm: "none" },
                                          }}>
                                        <Grid item xs={12} sm={3}>
                                          <Box display="flex" alignItems="center">
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                              {item}
                                            </Typography>
                                          </Box>
                                        </Grid>
                                        {ConsiglioStato != undefined ? (
                                        <Grid item xs={12} sm={8}>
                                          <Box
                                            display="flex"
                                            flexDirection={{ xs: "column", sm: "row" }}
                                            alignItems={{ xs: "flex-start", sm: "center" }}
                                            gap={{ xs: 2, sm: 6 }}
                                            width="100%"
                                          >
                                          <div className="presence-invited-wrap" style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                              padding: "8px 0",
                                            }}>
                                            <label htmlFor={`stato-select-${index}`} >
                                                Invitato
                                            </label>
                                              <Select                                                
                                                styles={{
                                                  container: (base) => ({ ...base, flex: 1 }),
                                                  singleValue: (base) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                    marginLeft: 0,
                                                  }),
                                                  valueContainer: (base) => ({
                                                    ...base,
                                                    justifyContent: "flex-start",
                                                  }),
                                                  menu: (base) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                  }),
                                                  option: (base, state) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                    color: "#333",
                                                  }),
                                                }}                                       
                                                options={options}
                                                id={`stato-select-${index}`}
                                                value= {options.find(opt => opt.value === (ConsiglioStato[index] ?? 0))}
                                                                                                                                              
                                                onChange={(event) => handleChange4(event, "consiglio", item, index)}
                                                isDisabled={disabled}
                                              />
                                                
                                              
                                            </div>

                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  className="presence-checkbox"
                                                  sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }}
                                                  style={{ color: "#30720f" }}
                                                  disabled={disabled }
                                                  checked={ConsiglioPresenze[index] === 1}
                                                  onChange={(event) => handleChange3(event, "consiglio", item, index)}
                                                />
                                              }
                                              label="Presente"
                                              sx={{ color: "black", marginLeft: 0 }}
                                            />
                                          </Box>
                                        </Grid>
                                        ):(
                                          <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
                                          <FormControlLabel key={uuidv4()} className="presence-simple-check" sx={{ marginLeft: 0 }} style={{color:"black"}} control={<Checkbox key={uuidv4()} className="presence-checkbox" sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }} style ={{color: "#30720f"}} disabled={disabled} checked={(ConsiglioPresenze[index]=== 1) ?? false}/>} label="Presente" onChange={(event) => handleChange3(event, "consiglio",item, index)}/>
                                        </Grid>
                                        )}
                                          <Grid item xs={12} sm={1}>
                                            {loading2==item ? (
                                                <div style={{marginRight: "20px",marginTop:"5px"}}>
                                                <CircularProgress size={22} color= "success" />
                                                </div>
                                            ):( <></> )}
                                        </Grid>

                                    </Grid>
                                ))}
                                <br />
                            </div>
                        ):(<></>)}    
                         {ComitatoList.length>0 ?(   
                            <div className="common-list" key={uuidv4()} style = {{alignItems: "center", display: "block", height: "100%", paddingTop:"20px", justifyContent: "center"}}>
                                <p className="presence-section-title" style={{ fontSize: "16px", letterSpacing: "1px", width: "100%", textAlign: "left"}}>
                                    Componenti Comitato di Gestione
                                </p>
                                {ComitatoList.map((item, index) => (                                
                                    <Grid
                                          key={uuidv4()}
                                          container
                                          alignItems="center"
                                          sx={{
                                            py: { xs: 2, sm: 1 },
                                            px: 2,
                                            mx: { xs: 1.5, sm: 0 },
                                            width: { xs: "calc(100% - 24px)", sm: "100%" },
                                            mb: { xs: 2, sm: 1 },
                                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#f0f0f0", // alternanza
                                            border: { xs: "1px solid #e0e0e0", sm: "none" },
                                            borderRadius: { xs: 2, sm: 0 },
                                            boxShadow: { xs: 1, sm: "none" },
                                          }}>
                                        <Grid item xs={12} sm={3}>
                                          <Box display="flex" alignItems="center">
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                              {item}
                                            </Typography>
                                          </Box>
                                        </Grid>
                                        {ComitatoStato != undefined ? (
                                        <Grid item xs={12} sm={8}>
                                          <Box
                                            display="flex"
                                            flexDirection={{ xs: "column", sm: "row" }}
                                            alignItems={{ xs: "flex-start", sm: "center" }}
                                            gap={{ xs: 2, sm: 6 }}
                                            width="100%"
                                          >
                                          <div className="presence-invited-wrap" style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                              padding: "8px 0",
                                            }}>
                                            <label htmlFor={`stato-select-${index}`} >
                                                Invitato
                                            </label>
                                              <Select                                                
                                                styles={{
                                                  container: (base) => ({ ...base, flex: 1 }),
                                                  singleValue: (base) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                    marginLeft: 0,
                                                  }),
                                                  valueContainer: (base) => ({
                                                    ...base,
                                                    justifyContent: "flex-start",
                                                  }),
                                                  menu: (base) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                  }),
                                                  option: (base, state) => ({
                                                    ...base,
                                                    textAlign: "left",
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                    color: "#333",
                                                  }),
                                                }}                                       
                                                options={options}
                                                id={`stato-select-${index}`}
                                                value= {options.find(opt => opt.value === (ComitatoStato[index] ?? 0))}
                                                                                                                                              
                                                onChange={(event) => handleChange4(event, "comitato", item, index)}
                                                isDisabled={disabled}
                                              />
                                                
                                              
                                            </div>

                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  className="presence-checkbox"
                                                  sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }}
                                                  style={{ color: "#30720f" }}
                                                  disabled={disabled }
                                                  checked={ComitatoPresenze[index] === 1}
                                                  onChange={(event) => handleChange3(event, "comitato", item, index)}
                                                />
                                              }
                                              label="Presente"
                                              sx={{ color: "black", marginLeft: 0 }}
                                            />
                                          </Box>
                                        </Grid>
                                        ):(
                                          <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
                                          <FormControlLabel key={uuidv4()} className="presence-simple-check" sx={{ marginLeft: 0 }} style={{color:"black"}} control={<Checkbox key={uuidv4()} className="presence-checkbox" sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }} style ={{color: "#30720f"}} disabled={disabled} checked={(ComitatoPresenze[index]=== 1) ?? false}/>} label="Presente" onChange={(event) => handleChange3(event, "comitato",item, index)}/>
                                        </Grid>
                                        )}
                                          <Grid item xs={12} sm={1}>
                                            {loading2==item ? (
                                                <div style={{marginRight: "20px",marginTop:"5px"}}>
                                                <CircularProgress size={22} color= "success" />
                                                </div>
                                            ):( <></> )}
                                        </Grid>

                                    </Grid>
                                ))}
                                <br />
                            </div>
                            ):(<></>)}     
                            {RevisoriList.length>0 ?(   
                            <div className="common-list" key={uuidv4()} style = {{alignItems: "center", display: "block", height: "100%", paddingTop:"20px", justifyContent: "center"}}>
                                <p className="presence-section-title" style={{ fontSize: "16px", letterSpacing: "1px", width: "100%", textAlign: "left"}}>
                                Componenti Collegio Sindacale
                                </p>
                                {RevisoriList.map((item, index) => (                                 
                                    <Grid
                                    key={uuidv4()}
                                    container
                                    alignItems="center"
                                    sx={{
                                      py: { xs: 2, sm: 1 },
                                      px: 2,
                                      mx: { xs: 1.5, sm: 0 },
                                      width: { xs: "calc(100% - 24px)", sm: "100%" },
                                      mb: { xs: 2, sm: 1 },
                                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#f0f0f0", // alternanza
                                      border: { xs: "1px solid #e0e0e0", sm: "none" },
                                      borderRadius: { xs: 2, sm: 0 },
                                      boxShadow: { xs: 1, sm: "none" },
                                    }}>
                                  <Grid item xs={12} sm={3}>
                                    <Box display="flex" alignItems="center">
                                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                        {item}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  {RevisoriStato != undefined ? (
                                  <Grid item xs={12} sm={8}>
                                    <Box
                                      display="flex"
                                      flexDirection={{ xs: "column", sm: "row" }}
                                      alignItems={{ xs: "flex-start", sm: "center" }}
                                      gap={{ xs: 2, sm: 6 }}
                                      width="100%"
                                    >
                                    <div className="presence-invited-wrap" style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        padding: "8px 0",
                                      }}>
                                      <label htmlFor={`stato-select-${index}`} >
                                          Invitato
                                      </label>
                                        <Select                                                
                                          styles={{
                                            container: (base) => ({ ...base, flex: 1 }),
                                            singleValue: (base) => ({
                                              ...base,
                                              textAlign: "left",
                                              marginLeft: 0,
                                            }),
                                            valueContainer: (base) => ({
                                              ...base,
                                              justifyContent: "flex-start",
                                            }),
                                            menu: (base) => ({
                                              ...base,
                                              textAlign: "left",
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              textAlign: "left",
                                              backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                              color: "#333",
                                            }),
                                          }}                                       
                                          options={options}
                                          id={`stato-select-${index}`}
                                          value= {options.find(opt => opt.value === (RevisoriStato[index] ?? 0))}
                                                                                                                                        
                                          onChange={(event) => handleChange4(event, "revisori", item, index)}
                                          isDisabled={disabled}
                                        />
                                          
                                        
                                      </div>

                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            className="presence-checkbox"
                                            sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }}
                                            style={{ color: "#30720f" }}
                                            disabled={disabled}
                                            checked={RevisoriPresenze[index] === 1}
                                            onChange={(event) => handleChange3(event, "revisori", item, index)}
                                          />
                                        }
                                        label="Presente"
                                        sx={{ color: "black", marginLeft: 0 }}
                                      />
                                    </Box>
                                  </Grid>
                                  ):(
                                    <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
                                    <FormControlLabel key={uuidv4()} className="presence-simple-check" sx={{ marginLeft: 0 }} style={{color:"black"}} control={<Checkbox key={uuidv4()} className="presence-checkbox" sx={{ padding: 0, marginLeft: 0, marginRight: "6px" }} style ={{color: "#30720f"}} disabled={disabled} checked={(RevisoriPresenze[index]=== 1) ?? false}/>} label="Presente" onChange={(event) => handleChange3(event, "revisori",item, index)}/>
                                  </Grid>
                                  )}
                                    <Grid item xs={12} sm={1}>
                                      {loading2==item ? (
                                          <div style={{marginRight: "20px",marginTop:"5px"}}>
                                          <CircularProgress size={22} color= "success" />
                                          </div>
                                      ):( <></> )}
                                  </Grid>

                              </Grid>
                              ))}
                            </div>
                            ):(<></>)}   
                        </div>
                        <br />
                        {!disabled ? (
                        <button className="button202" disabled={disabled} >Invia lista partecipanti</button>
                        ):(<></>)}
                        <br /><br />
                    </div>
                </form>
                        </Grid> 
            </Grid>
            </LocalizationProvider>
            
            </Container>
      </div>
      )}

            {alert}

      </div>
  );

  }
